if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.removeInputsDuplicates();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            this.resetGiftInput();
          });
      }

      removeInputsDuplicates() {
        const observedInputs = new Set();
        const inputs = [...this.form.elements].filter( input => input.type == "hidden")

        inputs.forEach((input) => {
          if (observedInputs.has(input.name)) {
            input.disabled = true;
          } else {
            observedInputs.add(input.name);
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart + this.getCurrentPrice();
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]')
          ? this.form.querySelector('[name=id]')
          : this.form.querySelector('input.product-variant-id');
      }

      resetGiftInput() {
        const productContainer = this.form.closest('.product');
        if (productContainer) {
          const mainInput = productContainer.querySelector('quantity-input .quantity__input');
          const giftInput = productContainer.querySelector('.product-gift input.product-gift__quantity');
          const giftInputs = productContainer.querySelectorAll('.product-gift input');
          if (giftInput) {
            if (giftInput.getAttribute('data-max-quantity') != 'null') {
              giftInput.value = 0;
              giftInputs.forEach((input) => (input.disabled = true));
            } else {
              giftInput.value = mainInput ? mainInput.value : 1;
            }
          }
        }
      }

      getCurrentPrice() {
        const dataPrices = this.querySelector('[data-product-price]');
        if (!dataPrices) return '';

        const variantId = this.variantIdInput?.value;
        if (!variantId) return '';

        try {
          const jsonPrices = JSON.parse(dataPrices.textContent);
          const currentPriceItem = jsonPrices.find(({ id }) => id == variantId);

          return currentPriceItem ? ` (${currentPriceItem.price})` : '';
        } catch (error) {
          console.error('Failed to parse price data:', error);
          return '';
        }
      }
    },
  );
}
